import React from 'react';
import { Modal, Button } from 'antd';
import { AWAssetDto, AWStageDto } from '@api/Api';
import { CrossIcon } from '@icons';
import './RestartApprovalModal.less';

interface RestartApprovalModalProps {
  visible: boolean;
  approvalWorkflowName?: string;
  awAsset?: AWAssetDto | null;
  stage?: AWStageDto & { stageNumber: number };
  onCancel: () => void;
  onConfirm: () => void;
}

export default function RestartApprovalModal(props: RestartApprovalModalProps) {
  const { visible, awAsset, approvalWorkflowName, stage, onCancel, onConfirm } =
    props;
  return (
    <Modal
      open={visible}
      footer={null}
      destroyOnClose
      centered={true}
      closeIcon={<CrossIcon />}
      width={500}
      zIndex={1010}
      onCancel={(e) => {
        e.stopPropagation();
        onCancel();
      }}
    >
      <div className="modal_container" onClick={(e) => e.stopPropagation()}>
        <h2
          className="modal_container__title"
          style={{ fontSize: 22, marginBottom: '0.5em' }}
        >
          Restart {stage ? 'stage' : 'approval'}
        </h2>
        {!!approvalWorkflowName && (
          <p className="modal_container__subtitle">
            You will lose all data entered into
            <span className="restart-approval-modal__name">
              {approvalWorkflowName}
            </span>{' '}
            approval routing. Do you want to reset all data and restart?
          </p>
        )}
        {!!stage && (
          <p className="modal_container__subtitle">
            You will lose all data entered into the approval routing{' '}
            <span className="restart-approval-modal__stage">
              starting from stage
              <span className="restart-approval-modal__stage-number">
                {stage.stageNumber}
              </span>
              <span className="restart-approval-modal__stage-name">
                {stage.name}
              </span>
              .
            </span>
            Do you want to reset all data and restart?
          </p>
        )}
        {!!awAsset && (
          <p className="modal_container__subtitle">
            You will lose all data entered into approval routing for
            <span className="restart-approval-modal__name">
              {awAsset?.name}.{awAsset?.extension}
            </span>
            <span className="restart-approval-modal__version">
              v{awAsset?.versionsCount}
            </span>
            {!!stage && (
              <span className="restart-approval-modal__stage">
                starting from stage
                <span className="restart-approval-modal__stage-number">
                  {stage.stageNumber}
                </span>
                <span className="restart-approval-modal__stage-name">
                  {stage.name}
                </span>
                .
              </span>
            )}
            Do you want to reset all data and restart?
          </p>
        )}
        <div className="modal_container__actions">
          <Button
            type="text"
            size="large"
            style={{
              marginRight: '16px',
              border: 'none',
              height: 48,
              padding: '8px 32px'
            }}
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            size="large"
            onClick={(e) => {
              e.stopPropagation();
              onConfirm();
            }}
            style={{ width: 216, height: 48, padding: '8px 15px' }}
          >
            Restart
          </Button>
        </div>
      </div>
    </Modal>
  );
}
